/*********************** Custom JS for Boost AI Search & Discovery  ************************/

(function () {
  'use strict';

  /* ---------------------------------------------------------------
     CONFIG
     --------------------------------------------------------------- */
  var MOBILE_BP = 749;
  var MOBILE_SLIDES = 3;
  var MOBILE_SCROLL = 3;

  /* ---------------------------------------------------------------
     1. CSS INJECTION — Boost SD kendi CSS'ini dinamik yukledigi icin,
        bizim gorsel kurallarimizi DOM'un sonuna <style> olarak ekleyerek
        cascade sirasinda en son yuklenmesini sagliyoruz.

        NOT: Slider layout (width, position, transform) burada YOKTUR.
        Sadece gorsel stiller (renk, font, border, padding) var.
     --------------------------------------------------------------- */
  function injectOverrideCSS() {
    if (document.getElementById('boost-sd-custom-override')) return;

    var style = document.createElement('style');
    style.id = 'boost-sd-custom-override';
    style.textContent = [

      /* --- Product Card (kare degil, bilgi altta) --- */
      'html body .boost-sd__recommendation .boost-sd__product-item,',
      'html body .boost-sd__recommendation .boost-sd__product-item.boost-sd__product-item--no-border {',
      '  background: #fff !important;',
      '  border: none !important;',
      '  border-radius: 0 !important;',
      '  overflow: visible !important;',
      '  box-shadow: none !important;',
      '  padding: 0 !important;',
      '  display: flex !important;',
      '  flex-direction: column !important;',
      '}',

      /* --- Image container (kare, overflow visible for button) --- */
      'html body .boost-sd__recommendation .boost-sd__product-item-grid-view-layout-image {',
      '  aspect-ratio: 1/1 !important;',
      '  border: 1px solid #e8e8e8 !important;',
      '  border-radius: 8px !important;',
      '  overflow: visible !important;',
      '  background: #fff !important;',
      '  box-shadow: 0 1px 3px rgba(0,0,0,0.06) !important;',
      '  flex-shrink: 0 !important;',
      '  display: flex !important;',
      '  flex-direction: column !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__product-link-image {',
      '  flex: 1 1 100% !important;',
      '  min-height: 0 !important;',
      '  display: flex !important;',
      '  flex-direction: column !important;',
      '  overflow: hidden !important;',
      '  border-radius: 8px !important;',
      '}',

      /* --- Image Wrapper (flex fill) --- */
      'html body .boost-sd__recommendation .boost-sd__product-image-wrapper {',
      '  background: #fff !important;',
      '  padding: 0 !important;',
      '  box-sizing: border-box !important;',
      '  flex: 1 !important;',
      '  min-height: 0 !important;',
      '  border-radius: 8px !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__product-image-img {',
      '  position: absolute !important;',
      '  top: 0 !important;',
      '  left: 0 !important;',
      '  width: 100% !important;',
      '  height: 100% !important;',
      '  object-fit: cover !important;',
      '  object-position: center center !important;',
      '}',

      /* --- Product Title (2 satir, okunabilir) --- */
      'html body .boost-sd__recommendation .boost-sd__product-title {',
      '  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif !important;',
      '  font-weight: 400 !important;',
      '  font-size: 13px !important;',
      '  line-height: 18px !important;',
      '  color: #333 !important;',
      '  display: -webkit-box !important;',
      '  -webkit-line-clamp: 2 !important;',
      '  -webkit-box-orient: vertical !important;',
      '  overflow: hidden !important;',
      '  text-overflow: ellipsis !important;',
      '  text-align: left !important;',
      '  white-space: normal !important;',
      '  word-break: break-word !important;',
      '  min-height: 36px !important;',
      '}',

      /* --- Info Wrapper (kart altinda, buton icin bosluk) --- */
      'html body .boost-sd__recommendation .boost-sd__product-info-wrapper {',
      '  padding: 20px 4px 4px 4px !important;',
      '  flex-grow: 0 !important;',
      '  flex-shrink: 0 !important;',
      '}',

      /* --- Price - ja-product-card__price stili --- */
      'html body .boost-sd__recommendation .boost-sd__product-price--default,',
      'html body .boost-sd__recommendation .boost-sd__format-currency {',
      '  font-family: "Inter", sans-serif !important;',
      '  font-weight: 500 !important;',
      '  font-size: 15px !important;',
      '  line-height: 18px !important;',
      '  color: #333 !important;',
      '}',

      /* Sadece indirimli urunlerde SATIS fiyati yesil - s/del HARIC */
      'html body .boost-sd__recommendation .boost-sd__product-price:has(s) .boost-sd__product-price--default,',
      'html body .boost-sd__recommendation .boost-sd__product-price:has(del) .boost-sd__product-price--default,',
      'html body .boost-sd__recommendation .boost-sd__product-price:has(.boost-sd__product-price--compare) .boost-sd__product-price--default {',
      '  color: #44b183 !important;',
      '}',
      /* s/del - ana element uzerine cizgi */
      'html body .boost-sd__recommendation s,',
      'html body .boost-sd__recommendation del {',
      '  color: #999 !important;',
      '  text-decoration: line-through !important;',
      '  text-decoration-color: #c50d00 !important;',
      '  text-decoration-thickness: 1.5px !important;',
      '  text-decoration-skip-ink: none !important;',
      '}',
      /* s/del ICINDEKI child elementler - cizgi YOK, sadece renk */
      'html body .boost-sd__recommendation s *,',
      'html body .boost-sd__recommendation s .boost-sd__format-currency,',
      'html body .boost-sd__recommendation del *,',
      'html body .boost-sd__recommendation del .boost-sd__format-currency {',
      '  color: #999 !important;',
      '  text-decoration: none !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__product-price {',
      '  margin-top: 0 !important;',
      '  padding: 0 !important;',
      '  text-align: left !important;',
      '  width: 100% !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__product-price-wrapper {',
      '  display: flex !important;',
      '  flex-direction: column !important;',
      '  align-items: flex-start !important;',
      '  gap: 4px !important;',
      '}',

      /* --- Compare Price - ja-product-card__discounted-price stili --- */
      'html body .boost-sd__recommendation .boost-sd__product-price--compare,',
      'html body .boost-sd__recommendation .boost-sd__product-price--compare *,',
      'html body .boost-sd__recommendation .boost-sd__product-price--compare span,',
      'html body .boost-sd__recommendation .boost-sd__product-price-content s,',
      'html body .boost-sd__recommendation .boost-sd__product-price-content s *,',
      'html body .boost-sd__recommendation .boost-sd__product-price-content del,',
      'html body .boost-sd__recommendation .boost-sd__product-price-content del *,',
      'html body .boost-sd__recommendation s,',
      'html body .boost-sd__recommendation s *,',
      'html body .boost-sd__recommendation del,',
      'html body .boost-sd__recommendation del * {',
      '  font-family: "Inter", sans-serif !important;',
      '  font-weight: 500 !important;',
      '  font-size: 13px !important;',
      '  line-height: 16px !important;',
      '  color: #999 !important;',
      '  margin-left: 0 !important;',
      '  text-decoration: line-through #c50d00 !important;',
      '  -webkit-text-decoration: line-through #c50d00 !important;',
      '  text-decoration-thickness: 1px !important;',
      '  -webkit-text-decoration-thickness: 1px !important;',
      '}',

      /* --- Add-to-Cart Button (Turuncu, kart kenarini asan) --- */
      'html body .boost-sd__recommendation .boost-sd__button--select-option,',
      'html body .boost-sd__recommendation .boost-sd__button--select-option.boost-sd__button--circle,',
      'html body .boost-sd__recommendation .boost-sd__button--select-option.boost-sd__button--icon {',
      '  width: 38px !important;',
      '  height: 38px !important;',
      '  min-width: 38px !important;',
      '  min-height: 38px !important;',
      '  border-radius: 50% !important;',
      '  border: none !important;',
      '  background: #004125 !important;',
      '  display: inline-flex !important;',
      '  justify-content: center !important;',
      '  align-items: center !important;',
      '  cursor: pointer !important;',
      '  padding: 0 !important;',
      '  color: #fff !important;',
      '  box-shadow: 0 2px 6px rgba(0,65,37,0.3) !important;',
      '  position: absolute !important;',
      '  bottom: -14px !important;',
      '  right: -4px !important;',
      '  z-index: 10 !important;',
      '  margin: 0 !important;',
      '  text-align: center !important;',
      '  line-height: 1 !important;',
      '  font-size: 0 !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__button--select-option:hover {',
      '  background: #00331d !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__button--select-option .boost-sd__icon {',
      '  display: flex !important;',
      '  justify-content: center !important;',
      '  align-items: center !important;',
      '  width: 100% !important;',
      '  height: 100% !important;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '  line-height: 0 !important;',
      '  position: absolute !important;',
      '  top: 0 !important;',
      '  left: 0 !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__button--select-option .boost-sd__icon svg {',
      '  width: 20px !important;',
      '  height: 20px !important;',
      '  fill: #fff !important;',
      '  display: block !important;',
      '  margin: 0 !important;',
      '  position: absolute !important;',
      '  top: 50% !important;',
      '  left: 50% !important;',
      '  transform: translate(-50%, -50%) !important;',
      '}',

      'html body .boost-sd__recommendation .boost-sd__button--select-option > span:not(.boost-sd__icon) {',
      '  display: none !important;',
      '}',

      /* --- Discount Badge --- */
      'html body .boost-sd__recommendation .boost-sd__product-badge,',
      'html body .boost-sd__recommendation .boost-sd__product-image-column--left > * {',
      '  background: #e53935 !important;',
      '  color: #fff !important;',
      '  border-radius: 4px !important;',
      '  padding: 3px 8px !important;',
      '  font-weight: 600 !important;',
      '  font-size: 11px !important;',
      '}',

      /* --- Slider Navigation --- */
      'html body .boost-sd__recommendation .boost-sd__slider-button {',
      '  background: #fff !important;',
      '  border: 1px solid #e0e0e0 !important;',
      '  border-radius: 50% !important;',
      '  box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;',
      '  position: absolute !important;',
      '  top: 50% !important;',
      '  transform: translateY(-50%) !important;',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '}',
      'html body .boost-sd__recommendation .boost-sd__slider-button * {',
      '  position: static !important;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '  top: auto !important;',
      '  left: auto !important;',
      '  right: auto !important;',
      '  bottom: auto !important;',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '}',
      'html body .boost-sd__recommendation .boost-sd__slider-button svg {',
      '  width: 20px !important;',
      '  height: 20px !important;',
      '  flex-shrink: 0 !important;',
      '}',
      'html body .boost-sd__recommendation .boost-sd__slider-button--next svg {',
      '  transform: rotate(-90deg) !important;',
      '}',
      'html body .boost-sd__recommendation .boost-sd__slider-button--prev svg {',
      '  transform: rotate(90deg) !important;',
      '}',

      /* Pagination dots gizle */
      'html body .boost-sd__recommendation .slick-dots,',
      'html body .boost-sd__recommendation [class*="slider-dots"],',
      'html body .boost-sd__recommendation [class*="slider-pagination"] {',
      '  display: none !important;',
      '}',

      /* --- Slider (position relative for arrows) --- */
      'html body .boost-sd__recommendation .boost-sd__slider {',
      '  overflow: visible !important;',
      '  position: relative !important;',
      '}',

      /* --- Slide Spacing --- */
      'html body .boost-sd__recommendation .boost-sd__slide {',
      '  padding: 0 2px !important;',
      '  box-sizing: border-box !important;',
      '}',

      /* --- Recommendation Heading (tek satir, sola dayali) --- */
      'html body .boost-sd__recommendation .boost-sd__recommendation-title-text,',
      'html body .boost-sd__recommendation [class*="recommendation-title-text"] {',
      '  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif !important;',
      '  font-weight: 600 !important;',
      '  font-size: 17px !important;',
      '  line-height: 22px !important;',
      '  color: #222 !important;',
      '  white-space: nowrap !important;',
      '  overflow: hidden !important;',
      '  text-overflow: ellipsis !important;',
      '  display: block !important;',
      '  max-width: 100% !important;',
      '  margin: 0 0 10px 0 !important;',
      '  padding: 0 !important;',
      '  word-break: normal !important;',
      '  text-align: left !important;',
      '}',

      /* Dekoratif cizgileri kaldir */
      'html body .boost-sd__recommendation [class*="recommendation-title"]::before,',
      'html body .boost-sd__recommendation [class*="recommendation-title"]::after {',
      '  display: none !important;',
      '  content: none !important;',
      '}',

      'html body .boost-sd__recommendation [class*="recommendation-title--"] {',
      '  text-align: left !important;',
      '  border: none !important;',
      '  display: block !important;',
      '  padding: 0 !important;',
      '  margin: 0 0 10px 0 !important;',
      '}',

      /* ===== MOBILE — native scroll + gorsel stiller ===== */
      '@media (max-width: ' + MOBILE_BP + 'px) {',

        /* Baslik — tek satir */
        'html body .boost-sd__recommendation .boost-sd__recommendation-title-text,',
        'html body .boost-sd__recommendation [class*="recommendation-title-text"] {',
        '  font-size: 15px !important;',
        '  line-height: 20px !important;',
        '  margin-bottom: 8px !important;',
        '  padding: 0 !important;',
        '}',

        /* Slick devre disi — native scroll */
        'html body .boost-sd__recommendation .slick-list {',
        '  overflow-x: auto !important;',
        '  overflow-y: hidden !important;',
        '  -webkit-overflow-scrolling: touch !important;',
        '  scroll-snap-type: x proximity !important;',
        '  scrollbar-width: none !important;',
        '  touch-action: pan-x pan-y !important;',
        '}',

        'html body .boost-sd__recommendation .slick-list::-webkit-scrollbar {',
        '  display: none !important;',
        '}',

        'html body .boost-sd__recommendation .slick-track {',
        '  transform: none !important;',
        '  transition: none !important;',
        '  width: auto !important;',
        '  display: flex !important;',
        '}',

        'html body .boost-sd__recommendation .slick-slide {',
        '  float: none !important;',
        '  flex-shrink: 0 !important;',
        '  scroll-snap-align: start !important;',
        '  width: calc(33.33vw - 6px) !important;',
        '}',

        'html body .boost-sd__recommendation .boost-sd__slide {',
        '  padding: 0 1px !important;',
        '}',

        'html body .boost-sd__recommendation .boost-sd__product-image-wrapper {',
        '  padding: 0 !important;',
        '}',

        'html body .boost-sd__recommendation .boost-sd__product-info-wrapper {',
        '  padding: 4px !important;',
        '}',

        'html body .boost-sd__recommendation .boost-sd__product-title {',
        '  font-size: 11px !important;',
        '  line-height: 15px !important;',
        '  min-height: 45px !important;',
        '  -webkit-line-clamp: 3 !important;',
        '  white-space: normal !important;',
        '}',

        'html body .boost-sd__recommendation .boost-sd__product-price--default,',
        'html body .boost-sd__recommendation .boost-sd__format-currency {',
        '  font-size: 12px !important;',
        '}',

        'html body .boost-sd__recommendation .boost-sd__product-price--compare,',
        'html body .boost-sd__recommendation .boost-sd__product-price-content s,',
        'html body .boost-sd__recommendation .boost-sd__product-price-content del {',
        '  font-size: 9px !important;',
        '  color: #999 !important;',
        '  text-decoration: line-through !important;',
        '  text-decoration-color: #c50d00 !important;',
        '  -webkit-text-decoration: line-through !important;',
        '  -webkit-text-decoration-color: #c50d00 !important;',
        '}',

        'html body .boost-sd__recommendation .boost-sd__button--select-option {',
        '  width: 34px !important;',
        '  height: 34px !important;',
        '  min-width: 34px !important;',
        '  min-height: 34px !important;',
        '  border-radius: 50% !important;',
        '  bottom: -12px !important;',
        '  right: -4px !important;',
        '}',

        'html body .boost-sd__recommendation .boost-sd__button--select-option .boost-sd__icon svg {',
        '  width: 18px !important;',
        '  height: 18px !important;',
        '}',

        'html body .boost-sd__recommendation .boost-sd__product-badge,',
        'html body .boost-sd__recommendation .boost-sd__product-image-column--left > * {',
        '  font-size: 8px !important;',
        '  padding: 2px 4px !important;',
        '}',

      '}',

      /* ===== Kucuk telefon ===== */
      '@media (max-width: 375px) {',
        'html body .boost-sd__recommendation .boost-sd__product-title {',
        '  font-size: 10px !important;',
        '  line-height: 14px !important;',
        '  min-height: 42px !important;',
        '  -webkit-line-clamp: 3 !important;',
        '  white-space: normal !important;',
        '}',
        'html body .boost-sd__recommendation .boost-sd__product-price--default,',
        'html body .boost-sd__recommendation .boost-sd__format-currency {',
        '  font-size: 12px !important;',
        '}',
        'html body .boost-sd__recommendation .boost-sd__product-info-wrapper {',
        '  padding: 4px !important;',
        '}',
        'html body .boost-sd__recommendation .boost-sd__product-image-wrapper {',
        '  padding: 0 !important;',
        '}',
        'html body .boost-sd__recommendation .boost-sd__button--select-option {',
        '  width: 30px !important;',
        '  height: 30px !important;',
        '  min-width: 30px !important;',
        '  min-height: 30px !important;',
        '  border-radius: 50% !important;',
        '  bottom: -10px !important;',
        '  right: -4px !important;',
        '}',
        'html body .boost-sd__recommendation .boost-sd__button--select-option .boost-sd__icon svg {',
        '  width: 16px !important;',
        '  height: 16px !important;',
        '}',
      '}',

      /* ===== Desktop 750+ — sepet sayfasinda 4 buyuk kart ===== */
      '@media (min-width: 750px) {',
        /* Slide genisligi JS tarafindan pixel olarak hesaplanir */
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__slide {',
        '  padding: 0 6px !important;',
        '}',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__slide {',
        '  padding: 0 8px !important;',
        '}',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__product-image-wrapper {',
        '  padding: 0 !important;',
        '  aspect-ratio: 4/5 !important;',
        '}',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__product-info-wrapper {',
        '  padding: 6px 10px 16px 10px !important;',
        '}',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__product-title {',
        '  font-size: 12px !important;',
        '  line-height: 17px !important;',
        '  min-height: 51px !important;',
        '  -webkit-line-clamp: 3 !important;',
        '  display: -webkit-box !important;',
        '  -webkit-box-orient: vertical !important;',
        '  overflow: hidden !important;',
        '  text-overflow: ellipsis !important;',
        '  white-space: normal !important;',
        '}',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__product-price--default,',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__format-currency {',
        '  font-size: 16px !important;',
        '  line-height: 22px !important;',
        '}',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__product-price--compare,',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__product-price-content s,',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__product-price-content del {',
        '  font-size: 14px !important;',
        '  color: #999 !important;',
        '  text-decoration: line-through !important;',
        '  text-decoration-color: #c50d00 !important;',
        '  -webkit-text-decoration: line-through !important;',
        '  -webkit-text-decoration-color: #c50d00 !important;',
        '}',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__button--select-option {',
        '  width: 46px !important;',
        '  height: 46px !important;',
        '  min-width: 46px !important;',
        '  min-height: 46px !important;',
        '}',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__button--select-option .boost-sd__icon svg {',
        '  width: 22px !important;',
        '  height: 22px !important;',
        '}',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__product-badge,',
        'html body .cart-page-content .boost-sd__recommendation .boost-sd__product-image-column--left > * {',
        '  font-size: 13px !important;',
        '  padding: 4px 10px !important;',
        '}',

        /* Parent section overflow fix */
        'html body .cart-page-content .shopify-section:has(.boost-sd__recommendation) {',
        '  overflow: visible !important;',
        '}',

        /* Bos recommendation section'larini gizle */
        'html body .cart-page-content .shopify-section:has(.boost-sd__recommendation):not(:has(.boost-sd__product-item)) {',
        '  display: none !important;',
        '  margin: 0 !important;',
        '  padding: 0 !important;',
        '  box-shadow: none !important;',
        '}',

        /* Bos recommendation container'larini gizle */
        'html body .boost-sd__recommendation:not(:has(.boost-sd__product-item)) {',
        '  display: none !important;',
        '}',
      '}',

      /* PrimeBadge */
      'html body .boost-sd__recommendation .insertedprimeb {',
      '  display: block !important;',
      '  visibility: visible !important;',
      '}',

      /* Desktop: parent section overflow fix */
      '@media (min-width: 750px) {',
        'html body .cart-page-content .shopify-section .boost-sd__recommendation {',
        '  overflow: visible !important;',
        '}',
      '}'

    ].join('\n');

    document.body.appendChild(style);
  }


  /* ---------------------------------------------------------------
     2. MOVE ADD-TO-CART BUTTON — Butonu bilgi alanindan gorsel
     alaninin icine tasir (absolute positioning icin gerekli).
     --------------------------------------------------------------- */
  function moveButtons() {
    document.querySelectorAll('.boost-sd__recommendation .boost-sd__product-item').forEach(function (item) {
      var btn = item.querySelector('.boost-sd__button--select-option');
      var imageArea = item.querySelector('.boost-sd__product-item-grid-view-layout-image');
      if (btn && imageArea && !imageArea.contains(btn)) {
        imageArea.appendChild(btn);
      }
    });
  }


  /* ---------------------------------------------------------------
     3. NATIVE SCROLL — Mobilde Slick carousel'i devre disi birakip
     native horizontal scroll kullaniyoruz. Slick inline style'lari
     (transform, width) override ediliyor.
     --------------------------------------------------------------- */

  function fixSliders() {
    var isDesktop = window.innerWidth > MOBILE_BP;

    /* Desktop: Slick varsayilan calissin, tek tek kaydir, section overflow fix */
    if (isDesktop) {
      document.querySelectorAll('.cart-page-content .boost-sd__recommendation').forEach(function (rec) {
        var section = rec.closest('.shopify-section');
        if (section) {
          section.style.setProperty('overflow', 'visible', 'important');
        }

        /* Slick ayarlari ve custom button handlers */
        var slickEl = rec.querySelector('.slick-initialized');
        if (slickEl && window.jQuery) {
          try {
            var $slick = jQuery(slickEl);

            /* 2'ser 2'ser kaydirma ayari */
            $slick.slick('slickSetOption', 'slidesToScroll', 2, true);

            /* Custom button handlers - tek tek kaydir + loop destegi */
            var slickInstance = $slick.slick('getSlick');
            var slideCount = slickInstance.slideCount;

            rec.querySelectorAll('.boost-sd__slider-button').forEach(function (btn) {
              var clone = btn.cloneNode(true);
              btn.parentNode.replaceChild(clone, btn);

              var isPrev = clone.classList.contains('boost-sd__slider-button--prev') ||
                           clone.querySelector('.boost-sd__icon--arrow-left') ||
                           clone.getAttribute('aria-label') === 'Previous';

              clone.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                if (isPrev) {
                  $slick.slick('slickPrev');
                } else {
                  $slick.slick('slickNext');
                }
              });
            });
          } catch (e) { /* Slick henuz hazir degil, sonraki poll'da denenecek */ }
        }
      });
      return;
    }

    var slideW = 'calc(33.33vw - 6px)';

    document.querySelectorAll('.boost-sd__recommendation').forEach(function (rec) {
      /* Zaten mobile icin fix uygulandiysa tekrar DOM'a dokunma */
      if (rec.getAttribute('data-mobile-fixed') === 'true') return;

      /* ----------------------------------------------------------
         Slick'i tamamen yok et (unslick) ve native scroll'a gec.
         Slick infinite modda klonlanmis slide'lar olusturur ve
         arka planda slide siralamasini degistirir — bu shuffle
         sorununa neden olur. unslick tum Slick yapisini kaldirir.
         ---------------------------------------------------------- */
      var slickEl = rec.querySelector('.slick-initialized');
      var slideNodes = [];
      var sliderContainer = null;

      if (slickEl && window.jQuery) {
        try {
          var $slick = jQuery(slickEl);
          var slickInstance = $slick.slick('getSlick');

          /* Gercek (klonlanmamis) slide iceriklerini DOM node olarak klonla */
          slickInstance.$slides.each(function () {
            slideNodes.push(this.cloneNode(true));
          });

          sliderContainer = slickEl;

          /* Slick'i tamamen yok et */
          $slick.slick('unslick');
        } catch (e) {
          /* Slick henuz hazir degil — sonraki poll'da denenecek */
          return;
        }
      }

      /* unslick sonrasi: Eger slide verileri kaydedildiyse,
         temiz bir scroll container olustur */
      if (slideNodes.length > 0 && sliderContainer) {
        /* Temiz bir scroll wrapper olustur */
        var scrollWrapper = document.createElement('div');
        scrollWrapper.className = 'boost-sd-native-scroll';
        scrollWrapper.style.cssText = [
          'display: flex',
          'overflow-x: auto',
          'overflow-y: hidden',
          '-webkit-overflow-scrolling: touch',
          'scroll-snap-type: x proximity',
          'touch-action: pan-x pan-y',
          'scrollbar-width: none',
          'gap: 0',
          'width: 100%'
        ].join(';');

        /* Her gercek slide'i scroll wrapper'a ekle (DOM cloneNode) */
        slideNodes.forEach(function (origNode) {
          var slide = document.createElement('div');
          slide.className = 'boost-sd-native-slide';
          slide.style.cssText = [
            'width: ' + slideW,
            'flex-shrink: 0',
            'scroll-snap-align: start',
            'box-sizing: border-box',
            'padding: 0 1px'
          ].join(';');
          /* Orijinal slide icindeki tum child node'lari tasi */
          while (origNode.firstChild) {
            slide.appendChild(origNode.firstChild);
          }
          scrollWrapper.appendChild(slide);
        });

        /* Eski icerik yerine yeni scroll wrapper'i koy */
        while (sliderContainer.firstChild) {
          sliderContainer.removeChild(sliderContainer.firstChild);
        }
        sliderContainer.appendChild(scrollWrapper);

        /* Scrollbar gizle (webkit) */
        if (!document.getElementById('boost-sd-native-scroll-style')) {
          var nativeStyle = document.createElement('style');
          nativeStyle.id = 'boost-sd-native-scroll-style';
          nativeStyle.textContent = '.boost-sd-native-scroll::-webkit-scrollbar{display:none!important}';
          document.head.appendChild(nativeStyle);
        }

        /* Ok butonlarini native scrollBy ile calistir */
        var firstNativeSlide = scrollWrapper.querySelector('.boost-sd-native-slide');
        var singleSlideW = firstNativeSlide ? firstNativeSlide.offsetWidth + 2 : window.innerWidth * 0.33;
        var scrollAmount = singleSlideW * 2;

        rec.querySelectorAll('.boost-sd__slider-button').forEach(function (btn) {
          var clone = btn.cloneNode(true);
          btn.parentNode.replaceChild(clone, btn);

          var isPrev = false;
          if (clone.classList.contains('boost-sd__slider-button--prev')) isPrev = true;
          if (clone.querySelector('.boost-sd__icon--arrow-left')) isPrev = true;
          if (clone.querySelector('[class*="left"]')) isPrev = true;
          if (clone.querySelector('[class*="prev"]')) isPrev = true;
          var ariaLabel = (clone.getAttribute('aria-label') || '').toLowerCase();
          if (ariaLabel.includes('prev') || ariaLabel.includes('önceki') || ariaLabel.includes('geri')) isPrev = true;

          var isNext = false;
          if (clone.classList.contains('boost-sd__slider-button--next')) isNext = true;
          if (clone.querySelector('.boost-sd__icon--arrow-right')) isNext = true;
          if (clone.querySelector('[class*="right"]')) isNext = true;
          if (clone.querySelector('[class*="next"]')) isNext = true;
          if (ariaLabel.includes('next') || ariaLabel.includes('sonraki') || ariaLabel.includes('ileri')) isNext = true;

          if (!isPrev && !isNext) {
            var allBtns = rec.querySelectorAll('.boost-sd__slider-button');
            var idx = Array.prototype.indexOf.call(allBtns, clone);
            isPrev = idx === 0;
            isNext = idx > 0;
          }

          clone.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            /* Snap'i gecici kapat — smooth scroll ile catismasini engelle */
            scrollWrapper.style.setProperty('scroll-snap-type', 'none', 'important');
            var direction = isPrev ? -scrollAmount : scrollAmount;
            scrollWrapper.scrollBy({
              left: direction,
              behavior: 'smooth'
            });
            /* Animasyon bitince snap'i geri ac */
            setTimeout(function () {
              scrollWrapper.style.setProperty('scroll-snap-type', 'x proximity', 'important');
            }, 450);
          });
        });
      } else {
        /* Fallback: Slick bulunamadiysa — klonlari gizle + native scroll */
        var track = rec.querySelector('.slick-track');
        if (track) {
          track.style.setProperty('transform', 'none', 'important');
          track.style.setProperty('transition', 'none', 'important');
          track.style.setProperty('width', 'auto', 'important');
          track.style.setProperty('display', 'flex', 'important');
        }

        /* Klonlanmis slide'lari gizle */
        rec.querySelectorAll('.slick-cloned').forEach(function (cloned) {
          cloned.style.setProperty('display', 'none', 'important');
        });

        var slickList = rec.querySelector('.slick-list');
        if (slickList) {
          slickList.style.setProperty('overflow-x', 'auto', 'important');
          slickList.style.setProperty('overflow-y', 'hidden', 'important');
          slickList.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
          slickList.style.setProperty('scroll-snap-type', 'x proximity', 'important');
          slickList.style.setProperty('touch-action', 'pan-x pan-y', 'important');
        }

        rec.querySelectorAll('.slick-slide:not(.slick-cloned)').forEach(function (s) {
          s.style.setProperty('width', slideW, 'important');
          s.style.setProperty('float', 'none', 'important');
          s.style.setProperty('flex-shrink', '0', 'important');
          s.style.setProperty('scroll-snap-align', 'start', 'important');
        });

        if (slickList) {
          var firstSlide = rec.querySelector('.slick-slide:not(.slick-cloned)');
          var fallbackSlideW = firstSlide ? firstSlide.offsetWidth + 2 : window.innerWidth * 0.33;
          var fallbackScrollAmount = fallbackSlideW * 2;

          rec.querySelectorAll('.boost-sd__slider-button').forEach(function (btn) {
            var bClone = btn.cloneNode(true);
            btn.parentNode.replaceChild(bClone, btn);
            var bIsPrev = bClone.classList.contains('boost-sd__slider-button--prev') ||
                          !!bClone.querySelector('[class*="left"], [class*="prev"]') ||
                          (bClone.getAttribute('aria-label') || '').toLowerCase().indexOf('prev') !== -1;
            bClone.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              /* Snap'i gecici kapat — smooth scroll ile catismasini engelle */
              slickList.style.setProperty('scroll-snap-type', 'none', 'important');
              slickList.scrollBy({ left: bIsPrev ? -fallbackScrollAmount : fallbackScrollAmount, behavior: 'smooth' });
              setTimeout(function () {
                slickList.style.setProperty('scroll-snap-type', 'x proximity', 'important');
              }, 450);
            });
          });
        }
      }

      /* Bu recommendation artik fix edildi, tekrar dokunma */
      rec.setAttribute('data-mobile-fixed', 'true');
    });
  }


  /* ---------------------------------------------------------------
     4. MUTATION OBSERVER — Boost SD widget'lari async yukleniyor.
     --------------------------------------------------------------- */
  /* ---------------------------------------------------------------
     HIDE EMPTY CART SECTIONS — Desktop'ta icerik render etmemis
     bos .shopify-section kutularini gizler.
     --------------------------------------------------------------- */
  function hideEmptyCartSections() {
    if (window.innerWidth <= MOBILE_BP) return;
    var sections = document.querySelectorAll('.cart-page-content > .shopify-section');
    sections.forEach(function(section) {
      // Ilk section'i (cart items) atla
      if (!section.previousElementSibling) return;
      // Boost SD urunleri varsa atla
      if (section.querySelector('.boost-sd__product-item')) return;
      // Cart footer icerigi varsa atla
      if (section.querySelector('.cart__footer, #main-cart-footer')) return;
      // Gercek icerik (baslik, form, tablo, resim) varsa atla
      if (section.querySelector('h1, h2, h3, form, table, article, img')) return;

      // Padding cikartilinca icerik yuksekligi 10px'den azsa bos kabul et
      var style = window.getComputedStyle(section);
      var padV = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
      var contentH = section.getBoundingClientRect().height - padV;
      if (contentH < 10) {
        section.style.display = 'none';
      }
    });
  }

  /* ---------------------------------------------------------------
     FIX COMPARE PRICES — ja-product-card__info stilini uygula
     Eski fiyat: gri metin (#999) + kirmizi ustu cizili (#c50d00)
     Yeni fiyat: yesil (#44b183)
     --------------------------------------------------------------- */
  function fixComparePrices() {
    // ONCELIK 1: s/del icindeki TUM elementleri GRI yap - BU EN ONEMLI
    document.querySelectorAll('.boost-sd__recommendation s, .boost-sd__recommendation del').forEach(function(el) {
      el.style.setProperty('color', '#999', 'important');
      el.style.setProperty('text-decoration', 'line-through', 'important');
      el.style.setProperty('text-decoration-color', '#c50d00', 'important');
      el.style.setProperty('text-decoration-thickness', '1.5px', 'important');
      el.style.setProperty('text-decoration-skip-ink', 'none', 'important');
      el.style.setProperty('display', 'inline', 'important');
      el.style.setProperty('vertical-align', 'baseline', 'important');
      // Child elementler - sadece renk, cizgi yok
      el.querySelectorAll('*').forEach(function(child) {
        child.style.setProperty('color', '#999', 'important');
        child.style.setProperty('text-decoration', 'none', 'important');
      });
    });

    // Eski fiyat (compare price) - gri + kirmizi cizgi
    var compareSelectors = [
      '.boost-sd__recommendation .boost-sd__product-price--compare',
      '.boost-sd__recommendation .boost-sd__format-currency--price-compare'
    ];

    compareSelectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(el) {
        el.style.setProperty('color', '#999', 'important');
        el.style.setProperty('font-family', '"Inter", sans-serif', 'important');
        el.style.setProperty('font-weight', '500', 'important');
        el.style.setProperty('font-size', '13px', 'important');
        el.style.setProperty('line-height', '16px', 'important');
        el.style.setProperty('text-decoration', 'line-through', 'important');
        el.style.setProperty('text-decoration-color', '#c50d00', 'important');
        el.style.setProperty('text-decoration-thickness', '1.5px', 'important');
        el.style.setProperty('text-decoration-skip-ink', 'none', 'important');
        el.querySelectorAll('*').forEach(function(child) {
          child.style.setProperty('color', '#999', 'important');
          child.style.setProperty('text-decoration', 'none', 'important');
        });
      });
    });

    // Yeni fiyat (indirimli urunlerde yesil) - SADECE s/del DISINDAKILER
    document.querySelectorAll('.boost-sd__recommendation .boost-sd__product-price').forEach(function(priceWrapper) {
      var hasCompare = priceWrapper.querySelector('.boost-sd__product-price--compare, s, del');
      if (hasCompare) {
        // price-default bul - AMA s/del icinde olmayanlar
        var defaultPrice = priceWrapper.querySelector('.boost-sd__product-price--default');

        // Eger price-default s/del icindeyse, NULL yap
        if (defaultPrice && (defaultPrice.closest('s') || defaultPrice.closest('del'))) {
          defaultPrice = null;
        }

        // Yoksa s/del DISINDAKI ilk format-currency bul
        if (!defaultPrice) {
          var allCurrencies = priceWrapper.querySelectorAll('.boost-sd__format-currency');
          for (var i = 0; i < allCurrencies.length; i++) {
            var curr = allCurrencies[i];
            if (!curr.closest('s') && !curr.closest('del') && !curr.classList.contains('boost-sd__format-currency--price-compare')) {
              defaultPrice = curr;
              break; // Ilk uygun elemani bul ve dur
            }
          }
        }

        // YALNIZCA s/del DISINDAKI elemente yesil uygula
        if (defaultPrice && !defaultPrice.closest('s') && !defaultPrice.closest('del')) {
          defaultPrice.style.setProperty('color', '#44b183', 'important');
          defaultPrice.style.setProperty('font-family', '"Inter", sans-serif', 'important');
          defaultPrice.style.setProperty('font-weight', '500', 'important');
          defaultPrice.style.setProperty('font-size', '15px', 'important');
          defaultPrice.style.setProperty('line-height', '18px', 'important');
        }
      }
    });

    // EN SON: s/del icindeki TUM elementleri KESINLIKLE TEKRAR gri yap
    document.querySelectorAll('.boost-sd__recommendation s, .boost-sd__recommendation del').forEach(function(el) {
      el.style.setProperty('color', '#999', 'important');
      el.style.setProperty('text-decoration', 'line-through', 'important');
      el.style.setProperty('text-decoration-color', '#c50d00', 'important');
      el.style.setProperty('text-decoration-thickness', '1.5px', 'important');
      el.style.setProperty('text-decoration-skip-ink', 'none', 'important');
      var children = el.getElementsByTagName('*');
      for (var i = 0; i < children.length; i++) {
        children[i].style.setProperty('color', '#999', 'important');
        children[i].style.setProperty('text-decoration', 'none', 'important');
      }
    });
  }

  function fixAll() {
    moveButtons();
    fixSliders();
    hideEmptyCartSections();
    fixComparePrices();
  }

  /* ---------------------------------------------------------------
     FORCE GRAY ON S/DEL - s/del icindeki elementleri ZORLA gri yapar
     --------------------------------------------------------------- */
  function forceGrayOnStrikethrough() {
    document.querySelectorAll('.boost-sd__recommendation s, .boost-sd__recommendation del').forEach(function(el) {
      el.style.setProperty('color', '#999', 'important');
      el.style.setProperty('text-decoration', 'line-through', 'important');
      el.style.setProperty('text-decoration-color', '#c50d00', 'important');
      el.style.setProperty('text-decoration-thickness', '1.5px', 'important');
      el.style.setProperty('text-decoration-skip-ink', 'none', 'important');
      var children = el.getElementsByTagName('*');
      for (var i = 0; i < children.length; i++) {
        children[i].style.setProperty('color', '#999', 'important');
        children[i].style.setProperty('text-decoration', 'none', 'important');
      }
    });
  }

  function init() {
    injectOverrideCSS();

    var fixTimer = null;

    // Ana observer - DOM degisikliklerini izle
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.classList && node.classList.contains('boost-sd__recommendation')) ||
            (node.querySelector && node.querySelector('.boost-sd__recommendation'))
          ) {
            clearTimeout(fixTimer);
            fixTimer = setTimeout(fixAll, 800);
            setTimeout(fixAll, 2000);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Style observer - s/del icindeki style degisikliklerini izle (debounced)
    var _isApplyingGray = false;
    var _grayDebounce = null;
    var styleObserver = new MutationObserver(function(mutations) {
      if (_isApplyingGray) return; // Kendi degisikliklerimizi yoksay
      var needsFix = false;
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (target.closest && (target.closest('s') || target.closest('del'))) {
          if (target.closest('.boost-sd__recommendation')) {
            needsFix = true;
            break;
          }
        }
      }
      if (needsFix) {
        clearTimeout(_grayDebounce);
        _grayDebounce = setTimeout(function() {
          _isApplyingGray = true;
          forceGrayOnStrikethrough();
          _isApplyingGray = false;
        }, 200);
      }
    });

    // Style observer'i body uzerinde baslat
    styleObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
      subtree: true
    });

    setTimeout(fixAll, 1500);
    setTimeout(fixAll, 3000);
    setTimeout(fixAll, 5000);

    /* Ilk 15 saniye boyunca kontrol et — urunler yuklendiyse erken dur */
    var pollCount = 0;
    var pollInterval = setInterval(function () {
      var hasProducts = document.querySelector('.boost-sd__recommendation .boost-sd__product-item');
      var allFixed = true;
      document.querySelectorAll('.boost-sd__recommendation').forEach(function(r) {
        if (window.innerWidth <= MOBILE_BP && r.getAttribute('data-mobile-fixed') !== 'true') allFixed = false;
      });
      fixAll();
      forceGrayOnStrikethrough();
      pollCount++;
      /* Urunler yuklendi ve slider fix edildiyse erken dur */
      if ((hasProducts && allFixed) || pollCount >= 15) clearInterval(pollInterval);
    }, 1000);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      /* Resize'da mobile flag'leri temizle — yeni boyut icin yeniden fix gerekebilir */
      document.querySelectorAll('.boost-sd__recommendation[data-mobile-fixed]').forEach(function(r) {
        r.removeAttribute('data-mobile-fixed');
      });
      resizeTimer = setTimeout(fixSliders, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* ---------------------------------------------------------------
   BOOST SD SIDE CART SUMMARY BOX
   Sepet drawer'ına summary box ekler
   --------------------------------------------------------------- */
(function() {
  'use strict';

  function createSummaryBox() {
    // Boost SD cart footer'ı bul
    const cartFooter = document.querySelector('.boost-sd__cart-footer');

    if (!cartFooter) {
      return;
    }

    // Zaten ekli mi kontrol et
    if (document.getElementById('boost-sd-summary-box')) {
      updateSummaryBox();
      return;
    }

    // Summary box DOM ile güvenli şekilde oluştur
    const summaryBox = document.createElement('div');
    summaryBox.id = 'boost-sd-summary-box';
    summaryBox.className = 'boost-sd-summary-box';

    // Price
    const priceDiv = document.createElement('div');
    priceDiv.className = 'boost-sd-summary-box__price';
    priceDiv.id = 'boost-sd-summary-price';
    const priceLabel = document.createElement('span');
    priceLabel.className = 'boost-sd-summary-box__price-label';
    priceLabel.textContent = 'Toplam:';
    priceDiv.appendChild(priceLabel);
    const currentPriceSpan = document.createElement('span');
    currentPriceSpan.className = 'boost-sd-summary-box__price-current';
    currentPriceSpan.textContent = '0,00₺';
    priceDiv.appendChild(currentPriceSpan);
    summaryBox.appendChild(priceDiv);

    // Cart footer'ın EN BAŞINA ekle - boost-sd__cart-price'ın yerine
    cartFooter.insertBefore(summaryBox, cartFooter.firstChild);

    // Shipping — checkout butonunun ALTINA ekle (footer'ın en sonuna)
    const shippingDiv = document.createElement('div');
    shippingDiv.className = 'boost-sd-summary-box__shipping';
    shippingDiv.id = 'boost-sd-shipping';
    shippingDiv.textContent = '2500₺ üzeri ücretsiz kargo';
    cartFooter.appendChild(shippingDiv);

    // İlk güncelleme
    updateSummaryBox();
  }

  function updateSummaryBox() {
    const summaryPriceElement = document.getElementById('boost-sd-summary-price');
    const shippingElement = document.getElementById('boost-sd-shipping');

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartTotal = cart.total_price || 0;

        // Calculate original price
        let originalPrice = 0;
        if (cart.items && cart.items.length > 0) {
          cart.items.forEach(item => {
            const itemOriginalPrice = item.compare_at_price || item.price;
            originalPrice += itemOriginalPrice * item.quantity;
          });
        }

        // Update price display
        if (summaryPriceElement) {
          summaryPriceElement.textContent = '';

          // Toplam label
          const priceLabel = document.createElement('span');
          priceLabel.className = 'boost-sd-summary-box__price-label';
          priceLabel.textContent = 'Toplam:';
          summaryPriceElement.appendChild(priceLabel);

          // Show old price if there's a difference
          if (originalPrice > cartTotal) {
            const oldPriceSpan = document.createElement('s');
            oldPriceSpan.className = 'boost-sd-summary-box__price-old';
            oldPriceSpan.textContent = (originalPrice / 100).toLocaleString('tr-TR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }) + '₺';
            summaryPriceElement.appendChild(oldPriceSpan);
          }

          const currentPriceSpan = document.createElement('span');
          currentPriceSpan.className = 'boost-sd-summary-box__price-current';
          currentPriceSpan.textContent = (cartTotal / 100).toLocaleString('tr-TR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }) + '₺';
          summaryPriceElement.appendChild(currentPriceSpan);
        }

        // Update shipping message
        if (shippingElement) {
          const freeShippingThreshold = 250000; // 2500 TL in kuruş
          const remaining = freeShippingThreshold - cartTotal;

          shippingElement.textContent = '';

          if (cartTotal >= freeShippingThreshold) {
            shippingElement.textContent = '🎉 Ücretsiz kargo kazandınız! 🎉';
          } else if (cartTotal > 0) {
            const formattedAmount = (remaining / 100).toLocaleString('tr-TR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });

            shippingElement.textContent = '🚚 Ücretsiz kargoya ';
            const strong = document.createElement('strong');
            strong.textContent = formattedAmount + '₺';
            shippingElement.appendChild(strong);
            shippingElement.appendChild(document.createTextNode(' kaldı 🚚'));
          } else {
            shippingElement.textContent = '2500₺ üzeri ücretsiz kargo';
          }
        }
      })
      .catch(error => {
        console.error('Error updating cart summary box:', error);
      });
  }

  // Boost SD cart açıldığında veya güncellendiğinde çalıştır
  function initCartSummaryBox() {
    // MutationObserver ile Boost SD cart'ı izle
    const observer = new MutationObserver(function(mutations) {
      for (let mutation of mutations) {
        for (let node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('boost-sd__cart')) {
              setTimeout(createSummaryBox, 500);
            } else if (node.querySelector && node.querySelector('.boost-sd__cart')) {
              setTimeout(createSummaryBox, 500);
            }
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Sayfa yüklenmesinde zaten varsa
    setTimeout(function() {
      if (document.querySelector('.boost-sd__cart')) {
        createSummaryBox();
      }
    }, 1000);

    // Sepet güncellemelerini izle
    if (window.Shopify && window.Shopify.pubsub) {
      if (typeof PUB_SUB_EVENTS !== 'undefined') {
        Shopify.pubsub.subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
          setTimeout(updateSummaryBox, 300);
        });
      }
    }

    // Periyodik kontrol (ilk 10 saniye)
    let checkCount = 0;
    const checkInterval = setInterval(function() {
      if (document.querySelector('.boost-sd__cart-footer') && !document.getElementById('boost-sd-summary-box')) {
        createSummaryBox();
      }
      checkCount++;
      if (checkCount >= 10) {
        clearInterval(checkInterval);
      }
    }, 1000);
  }

  // Başlat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartSummaryBox);
  } else {
    initCartSummaryBox();
  }

})();
